import {
	faFile,
	faFileZipper,
	faFileAudio,
	faFileCode,
	faFileExcel,
	faFileImage,
	faFilePdf,
	faFilePowerpoint,
	faFileWord,
	faFileInvoiceDollar,
} from '@fortawesome/pro-regular-svg-icons';

const supportedFileTypes = {
	// Adobe
	pdf: {
		icon: faFilePdf,
		label: 'Adobe PDF',
	},
	psd: {
		icon: faFile,
		label: 'Adobe Photoshop document',
	},
	ai: {
		icon: faFile,
		label: 'Adobe Illustrator file',
	},
	eps: {
		icon: faFile,
		label: 'Encapsulated PostScript file',
	},
	indd: {
		icon: faFile,
		label: 'Adobe InDesign document',
	},
	
	
	// Images
	png: {
		icon: faFileImage,
		label: 'PNG image',
	},
	jpg: {
		icon: faFileImage,
		label: 'JPEG photo',
	},
	jpeg: {
		icon: faFileImage,
		label: 'JPEG photo',
	},
	gif: {
		icon: faFileImage,
		label: 'GIF image',
	},
	tif: {
		icon: faFileImage,
		label: 'TIFF image',
	},
	tiff: {
		icon: faFileImage,
		label: 'TIFF image',
	},
	bmp: {
		icon: faFileImage,
		label: 'Bitmap image',
	},
	svg: {
		icon: faFileImage,
		label: 'SVG image',
	},
	
	
	// Microsoft
	doc: {
		icon: faFileWord,
		label: 'Microsoft Word document',
	},
	docx: {
		icon: faFileWord,
		label: 'Microsoft Word document',
	},
	wpd: {
		icon: faFileWord,
		label: 'Microsoft WordPerfect document',
	},
	wps: {
		icon: faFileWord,
		label: 'Microsoft Works word processor document',
	},
	xls: {
		icon: faFileExcel,
		label: 'Microsoft Excel spreadsheet',
	},
	xlsx: {
		icon: faFileExcel,
		label: 'Microsoft Excel spreadsheet',
	},
	xlsm: {
		icon: faFileExcel,
		label: 'Microsoft Excel spreadsheet (macro-enabled)',
	},
	ppt: {
		icon: faFilePowerpoint,
		label: 'Microsoft PowerPoint slideshow',
	},
	pptx: {
		icon: faFilePowerpoint,
		label: 'Microsoft PowerPoint slideshow',
	},
	pps: {
		icon: faFilePowerpoint,
		label: 'Microsoft PowerPoint slideshow',
	},
	ppsx: {
		icon: faFilePowerpoint,
		label: 'Microsoft PowerPoint slideshow',
	},
	
	
	// Apple
	pages: {
		icon: faFile,
		label: 'Apple Pages document',
	},
	numbers: {
		icon: faFile,
		label: 'Apple Numbers spreadsheet',
	},
	key: {
		icon: faFile,
		label: 'Apple Keynote presentation',
	},
	
	
	// Audio
	mp3: {
		icon: faFileAudio,
		label: 'MP3 audio file',
	},
	mpa: {
		icon: faFileAudio,
		label: 'MPEG-2 audio file',
	},
	m4a: {
		icon: faFileAudio,
		label: 'MPEG-4 audio file',
	},
	mp4: {
		icon: faFileAudio,
		label: 'MPEG-4 audio file',
	},
	wav: {
		icon: faFileAudio,
		label: 'WAV audio file',
	},
	oga: {
		icon: faFileAudio,
		label: 'Ogg audio file',
	},
	ogg: {
		icon: faFileAudio,
		label: 'Ogg audio file',
	},
	aac: {
		icon: faFileAudio,
		label: 'AAC audio file',
	},
	
	
	// Text
	txt: {
		icon: faFile,
		label: 'Text file',
	},
	rtf: {
		icon: faFile,
		label: 'Rich text format file',
	},
	odt: {
		icon: faFile,
		label: 'OpenDocument text document',
	},
	
	
	// Coding
	html: {
		icon: faFileCode,
		label: 'HTML file',
	},
	htm: {
		icon: faFileCode,
		label: 'HTML file',
	},
	css: {
		icon: faFileCode,
		label: 'Cascading style sheet',
	},
	js: {
		icon: faFileCode,
		label: 'JavaScript file',
	},
	
	
	// Archives
	zip: {
		icon: faFileZipper,
		label: 'ZIP archive file',
	},
	zipx: {
		icon: faFileZipper,
		label: 'Extended ZIP archive file',
	},
	'7z': {
		icon: faFileZipper,
		label: '7-Zip archive file',
	},
	gz: {
		icon: faFileZipper,
		label: 'gzipped file', // "gzip" is always stylized all lowercase
	},
	rar: {
		icon: faFileZipper,
		label: 'WinRAR archive file',
	},
	tar: {
		icon: faFileZipper,
		label: 'Tarball archive file',
	},
	
	
	// Miscellaneous
	csv: {
		icon: faFile,
		label: 'Comma-separated values file',
	},
	qbm: {
		icon: faFileInvoiceDollar,
		label: 'QuickBooks file',
	},
};

export default supportedFileTypes;
